import React, { useState } from 'react';
import { IconButton, Menu, Tooltip } from '@mui/material';
var wrapChildren = function (children, closeMenu) {
    return React.Children.map(children, function (child) {
        if (React.isValidElement(child)) {
            return React.createElement("div", { onClick: closeMenu }, child);
        }
        else {
            return child;
        }
    });
};
export var AccurityMenu = function (_a) {
    var renderOpenButton = _a.renderOpenButton, anchorOrigin = _a.anchorOrigin, transformOrigin = _a.transformOrigin, _b = _a.title, title = _b === void 0 ? '' : _b, children = _a.children;
    var _c = useState(null), menuAnchor = _c[0], setMenuAnchor = _c[1];
    var handleCloseMenu = function () { return setMenuAnchor(null); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { title: title },
            React.createElement(IconButton, { onClick: function (e) { return setMenuAnchor(e.currentTarget); } }, renderOpenButton())),
        React.createElement(Menu, { open: !!menuAnchor, anchorEl: menuAnchor, anchorOrigin: anchorOrigin || {
                vertical: 'bottom',
                horizontal: 'center',
            }, transformOrigin: transformOrigin || {
                vertical: 'top',
                horizontal: 'center',
            }, onClose: handleCloseMenu }, wrapChildren(children, handleCloseMenu))));
};
export default AccurityMenu;
//# sourceMappingURL=AccurityMenu.js.map